// Tiny presentational lookups for detail/review screens that only have an id to
// show (e.g. a dispatch line's productId, a genealogy leaf's locationId). Each is
// a thin wrapper over the matching single-record hook in ../api — react-query
// dedupes identical ids into one request. Mirrors features/stores-transfers/
// components/EntityNames.tsx exactly (this feature's own copy per S0 ownership).
import { Text } from '@mantine/core';
import { useCustomer, useLocation, useProduct, useSite } from '../api';

export function ProductName({ id }: { id: string }) {
  const { data, isLoading } = useProduct(id);
  return <Text span>{data ? `${data.sku} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function LocationName({ id }: { id: string }) {
  const { data, isLoading } = useLocation(id);
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function SiteName({ id }: { id: string }) {
  const { data, isLoading } = useSite(id);
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function CustomerName({ id }: { id: string | null | undefined }) {
  const { data, isLoading } = useCustomer(id ?? undefined);
  if (!id) return <Text span>—</Text>;
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}
